import { Dayjs } from "dayjs";
import { User, Flow, OfflineDays, ServiceAvailabilityException, Reservation, Service } from "./entities";
import React from "react";

//Creo un contexto del multistep que me sirve para que todos los componentes que lo usen,
//puedan acceder a las funciones para cambiar de step y guardar cambios de cada step
export const MultistepContext =
	React.createContext<MultistepContextValues | null>(null);

//Creo un contexto de isLogged para que los componentes que lo usen sepan si el usuario se loggeo y cómo lo hizo
export const LoginContext = React.createContext<LoginContextValues | null>(
	null
);

export const BusinessDataContext =
	React.createContext<BusinessDataContextValues | null>(null);

export interface MultistepContextValues {
	activeStep: number;
	reservation: Reservation;
	setReservation: (reservation: Reservation) => void;
	onNext: () => void;
	onPrev: () => void;
	onReset: () => void;
	onChangeStep: (step: number) => void;
	onChangeNumberDiners: (numberDiners: number) => void;
	onChangeDate: (date: Dayjs) => void;
	onChangeService: (service: Service) => void;
	onChangeTime: (scheduleTime: string | null) => void;
	onChangeLogin: (customer: User) => void;
	onChangeBookingFee: (bookingFee: number) => void;
	onSubmit: (reservation?: Reservation, step?: number) => void;
	reservationMade: boolean;
	setReservationMade: (newValue: boolean) => void;
}

export interface BusinessDataContextValues {
	flows: Flow[];
	selectedFlow: Flow | undefined;
	setSelectedFlow: (newValue: Flow) => void;
	services: Service[];
	offlineDays: OfflineDays[];
	serviceAvailabilityException: ServiceAvailabilityException[];
}

export interface LoginContextValues {
	isLogged: boolean;
	onLogin: () => void;
	onLogout: (onChangeLogin: (customer: User) => void) => void;
	isLoggedWithGoogle: boolean;
	onLoginWithGoogle: () => void;
	isCalledFromProfile: boolean;
	setIsCalledFromProfile: (newValue: boolean) => void;
}
